import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 导航栏
    activeIndex: '/', // 导航index
    screenWidth: 0, // 窗口大小
    // 首页
    homeSwipeList: '', // 首页轮播图
    homePopShow: false, // 首页弹出层控制
    productList: JSON.parse(localStorage.getItem('productList')) || [], // 产品
    productTitle: [], // 产品线

    // 新闻
    newsLIst: [], // 新闻中心
    newsTitle: [], // 新闻类型
    // 关于我们
    aboutFellows: [], // 合作伙伴
    // 解决方案
    solveTitle: [], // 解决方案类型
    // 客户案例
    caseInfo:[], // 详情
    caseHome:[]
  },
  getters: {
  },
  mutations: {
    // 导航---------------------------------------------
    // 修改首页轮播图
    getActiveIndex (state, activeIndex) {
      state.activeIndex = activeIndex
    },
    // 修改窗口大小
    getScreenWidth (state, screenWidth) {
      state.screenWidth = screenWidth
    },
    // 首页---------------------------------------------
    // 修改首页轮播图
    getHomeSwipeList (state, homeSwipeList) {
      state.homeSwipeList = homeSwipeList
    },
    // 修改首页弹出层控制
    getHomePopShow (state, homePopShow) {
      state.homePopShow = homePopShow
    },
    // 修改首页产品
    getProductList (state, productList) {
      state.productList = productList
    },
    // 修改产品线
    getProductTitle (state, productTitle) {
      state.productTitle = productTitle
    },
    // 新闻------------------------------------------------
    // 修改新闻中心
    getNewsLIst (state, newsLIst) {
      state.newsLIst = newsLIst
    },
    // 修改新闻中心
    getNewsTitle (state, newsTitle) {
      state.newsTitle = newsTitle
    },
    // 关于我们--------------------------------------------------
    // 合作伙伴
    getAboutFellows (state, aboutFellows) {
      state.aboutFellows = aboutFellows
    },
    // 解决方案--------------------------------------------------
    // 解决方案类型
    getSolveTitle (state, solveTitle) {
      state.solveTitle = solveTitle
    },
     // 客户案例--------------------------------------------------
    //  详情
     getCaseInfo (state,caseInfo){
      state.caseInfo = caseInfo
     },
    //  首页内容
     getCaseHome (state,caseHome){
      state.caseHome = caseHome
     }
  },
  actions: {
  },
  modules: {
  }
})
